<template>
    <b-container fluid>
        <b-row class="p-0 m-0 px-5">
            <b-col lg="12" class="m-0 p-0">
                <div class="position-relative mt-5"  style="height: 340px;">
                    <!-- Cover Photo -->
                    <div
                        class="w-100 bg-secondary position-absolute"
                        style="height: 250px; background-size: cover; background-position: center;"
                        :style="{ backgroundImage: coverPhoto ? 'url(' + coverPhoto + ')' : '' }"
                        >
                    </div>
                    <!-- Profile Photo with Pencil Icon -->
                    <div
                        class="position-absolute"
                        style="top: 130px; right: 50px;"
                    >
                        <div class="position-relative">
                            <!-- Profile Image or Default Avatar -->
                            <img
                                :src="profilePhoto || defaultAvatar"
                                class="rounded-circle border border-white bg-white"
                                style="width: 200px; height: 200px; object-fit: cover;"
                                alt="Profile Photo"
                            />
                            <!-- Pencil Icon -->
                            <button
                                class="btn btn-light btn-sm position-absolute"
                                style="top: 50px; right: 0;"
                                @click="$refs.fileInput.click()"
                                >
                                <b-icon-pencil></b-icon-pencil>
                                </button>
                                <!-- Hidden File Input -->
                                <input
                                type="file"
                                ref="fileInput"
                                @change="onFileChange"
                                accept="image/*"
                                style="display: none;"
                            />
                        </div>
                    </div>
                </div>
            </b-col>
            <b-col lg="12" class="m-0 p-4  right-out" >
                <b-row class="p-0 m-0">
                    <b-col lg="12" @click="goBack()" class="m-0 p-0 pt-1 text-left">
                        <svg width="24" style="cursor: pointer;"height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.90906 7.76521C9.50324 7.3906 8.87058 7.4159 8.49597 7.82172L5.2652 11.3217C4.9116 11.7047 4.9116 12.2952 5.26519 12.6782L8.49597 16.1783C8.87057 16.5841 9.50323 16.6094 9.90905 16.2348C10.3149 15.8602 10.3402 15.2276 9.96558 14.8217L8.28397 13L18 13C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11L8.284 11L9.96557 9.17829C10.3402 8.77247 10.3149 8.13981 9.90906 7.76521Z" fill="#777E91"/>
                        </svg>
                    </b-col>

                    <b-col lg="12" class="text-center">
                        <!-- <b-row class="pt-3">
                            <b-col lg="6" class="text-left"><strong><span class="reg-label">Статус идентификации : </span></strong>
                                <span class="text-val" v-if="kycResult.status=='unknown' || kycResult.status=='pending'">
                                    Ожидается
                                </span>
                                <span class="text-val text-success" v-if="kycResult.status=='verified'">
                                    Проверено
                                </span>
                                <span class="text-val text-danger" v-if="kycResult.status=='rejected'">
                                    Отклонено
                                </span>
                            </b-col>
                            <b-col lg="6" class="text-left"><strong>
                                <span class="reg-label">Статус классификации : </span></strong>
                                <span class="text-val">
                                    {{ kycResult.classification }}
                                </span>
                            </b-col>
                            <b-col lg="6" class="text-left"><strong><span class="reg-label">Электронная почта : </span></strong><span class="text-val">
                                {{ this.loginedUser.email }}
                            </span></b-col>
                            <b-col lg="6" class="text-left"><strong>
                                <span class="reg-label">Лимит инвестирования : </span></strong>
                                <span class="text-val text-success" v-if="kycResult.status=='verified'">
                                    1000$
                                </span>
                                <span v-else class="text-danger">
                                    0$
                                </span>
                            </b-col>

                            <b-col lg="12">
                                <hr style="border-color:white;">
                            </b-col>
                        </b-row>
                        <b-row class="pt-3">
                            <b-col lg="12">
                                <div class="d-flex justify-content-start">
                                    <b-button-group>
                                        <b-button variant="outline-secondary" @click="changeRoute('identify')">
                                            <b-icon icon="tools"></b-icon> Идентификация
                                        </b-button>
                                        <b-button variant="outline-secondary" @click="changeRoute('profile')">
                                            <b-icon icon="person-fill"></b-icon> Настройка профиля
                                        </b-button>
                                        <b-button variant="outline-secondary">
                                            <b-icon icon="inbox-fill"></b-icon> Банковские реквизиты
                                        </b-button>
                                        <b-button variant="outline-secondary">
                                            <b-icon icon="folder-fill"></b-icon> Цифровые кошельки
                                        </b-button>
                                        <b-button variant="outline-secondary">
                                            <b-icon icon="gear-fill"></b-icon> Безопасность аккаунта
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-col>
                        </b-row> -->
                        <b-row>
                            <b-col lg="12">
                                <router-view></router-view>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
      </b-container> 
</template>
<script>
    import axios from 'axios';
    import vue from 'vue';
    import {mapState} from 'vuex';
    import { apiDomain,getHeader } from '@/config/config';
    import { EventBus } from '@/EventBus';
    export default {
        name: 'Settings',
        data(){
            return {
                kycResult:{
                    status:"pending",
                    classification:"uknown"
                },
                coverPhoto: '', // Optional: URL of your cover photo
                profilePhoto: '', // Will hold user-uploaded image
                defaultAvatar: 'https://cdn-icons-png.flaticon.com/512/149/149071.png', // Default avatar URL
                coins:[],
                userForm:{

                },
                stForm:{
                    exchangeId:0,
                    sysComment:'',
                    exchangeStatus:'PENDING',
                    file:null
                }
            }  
        },
        methods:{
            onFileChange(event) {
                const file = event.target.files[0];
                if (file) {
                    this.profilePhoto = URL.createObjectURL(file);
                }
            },
            changeRoute(route){
                if (route === 'identify') {
                    this.$router.push('/identify')
                } 
                if (route === 'profile') {
                    this.$router.push('/profile')
                } 
               
            },
            goBack() {
                if (window.history.length > 1) {
                    window.history.back();
                } else {
                    this.$router.push("/landing");
                }
            },
            handleUpdate(){
                return ;
            },
            handleKycStatus(payload) {
                this.kycResult = payload;
            }   
        },
        mounted(){
            this.userForm = { ...this.loginedUser };
        },
        computed:{
            ...mapState([
                'loginedUser'
            ]),
           
        },
        created() {
            EventBus.$on('kyc-status', this.handleKycStatus);
        },
        beforeDestroy() {
            EventBus.$off('kyc-status', this.handleKycStatus); // clean up
        },
    }
</script>
<style scoped>
    
    .cancel-btn{
        border-radius: 8px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .cancel-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px; /* 114.286% */
    }
    .info-left{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .coin-sum{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;

        /* Body 2 (Bold) */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        line-height: 24px;
    }
     .reg-label{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 12px; /* 100% */
        text-transform: uppercase;
    }
    .reg-input,.text-val{
        color: var(--Neutrals-4, #777E90);
        /* Caption (Bold) */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 171.429% */
        appearance: none; 
        -webkit-appearance: none;
        -moz-appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        
        line-height: inherit;
        padding: 0;
        margin: 0;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
        
    }
    .text-val{border:none;}
    .convert-price{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .buy-convert{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .crypto-code{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; 
        letter-spacing: -0.96px;
    }
    .input-border{
        border-radius: 2px;
        border-right: 2px solid var(--Primary-1, #EFB914);
        height: 100px;
        margin-top: 30px;
    }
    .buy-input{ 
        width: 300px;
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 96px;
        font-style: normal;
        font-weight: 700;
        line-height: 96px;
        letter-spacing: -1.92px;

      
            
    }
    .buy-input:focus {
        /* Set the color of the caret (vertical line) */
        caret-color: var(--Neutrals-4, #18191D);
        
    }
    .buy-title1{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .payton-desc{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }
    .payton-link{
        color: var(--Neutrals-6, #E6E8EC);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
    }
    .crypto-main-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.96px;
    }
    .crypto-action-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    }
    .right-out{
        border-radius: 16px;
        background: var(--Shade-2-30, #18191D);

        /* depth/4 */
        box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
    }
    .crypto-row:hover{ 
        cursor: pointer;
        border-radius: 16px;
        background: var(--Neutrals-2, #23262F);
    }
    .step-item-step{
        width: 1px;
        height: 24px;
        border-right: 1px dashed #777E90;
    }
    .step-number{
        width: 33px;
        height: 33px;
        padding:7px 10px;
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;

        border-radius: 36px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .step-name{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    
</style>